import {useCallback, useSyncExternalStore} from 'react';

import {getReviewAnswerSnapshot, setReviewAnswerSnapshot, subscribeToReviewAnswer} from './reviews-answer-store';

export function useReviewAnswer(reviewId: number): [string, (value: string) => void] {
    const subscribe = useCallback((listener: () => void) => subscribeToReviewAnswer(reviewId, listener), [reviewId]);

    const getSnapshot = useCallback(() => getReviewAnswerSnapshot(reviewId), [reviewId]);

    const answer = useSyncExternalStore(subscribe, getSnapshot);

    const setAnswer = useCallback(
        (value: string) => {
            setReviewAnswerSnapshot(reviewId, value);
        },
        [reviewId]
    );

    return [answer, setAnswer];
}
